<template>
    <TransitionRoot as="template" :show="open">
        <Dialog as="div" class="fixed z-20 inset-0 overflow-y-auto">
            <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                    <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </TransitionChild>

                <!-- This element is to trick the browser into centering the modal contents. -->
                <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
                <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                    <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
                        <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                            <h1 class="font-semibold text-2xl leading-tight">For California Landlords and Property Managers</h1>
                            <h2 class="mt-4">California landlords and property managers are in compliance with the California Investigative Consumer Reporting Agencies Act (ICRAA).</h2>
                            <div class="flex gap-2 mt-4">
                                <label for="ca_icraa_compliance" class="flex gap-2 cursor-pointer z-100">
                                    <input 
                                        id="ca_icraa_compliance"
                                        type="checkbox" 
                                        v-model="form.ca_icraa_compliance"
                                        class="focus:ring-rent-risk-blue-400 h-4 w-4 text-rent-risk-blue-400 border-gray-300 rounded mt-1"
                                    />
                                    <span class="text-sm">
                                        I have read and agree to the 
                                        <a href="https://www.icraa.com" target="_blank" rel="noopener noreferrer" class="text-blue-600 underline hover:text-blue-800">
                                            California Consumer Credit Reporting Agencies Act Disclosure and Authorization.
                                        </a>
                                    </span>
                                </label>
                        </div>
                            <p v-text="form.errors.ca_icraa_compliance" class="text-red-500 text-sm"></p>
                        </div>
                        <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse gap-2">
                                <button type="button" class="mt-3 w-full inline-flex justify-center rounded-md border border-indigo-300 shadow-sm px-4 py-2 bg-rent-risk-blue-400 text-white font-medium hover:bg-rent-risk-blue-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-rent-risk-blue-400 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm" @click="submit">Save</button>
                        </div>
                    </div>
                </TransitionChild>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script setup>
import { Dialog, DialogTitle, TransitionChild, TransitionRoot, DialogOverlay } from '@headlessui/vue'
import {useForm} from "@inertiajs/vue3";

const props = defineProps({
    open: Boolean,
    property: Object,
});

const emit = defineEmits(['closeAlert']);

const form = useForm({
    property_id: props.property.id,
    is_ca_property: props.property.state === 'CA' || props.property.is_ca_property || false,
    ca_icraa_compliance: false,
})

function submit()
{
    if(!form.ca_icraa_compliance) {
        form.errors.ca_icraa_compliance = 'The California compliance must be acknowledged when the property is located in California.';
        return false;
    }

    form.post(route('properties.ca_compliance'), {
        onSuccess: () => {
            emit('closeAlert')
        }
    });
}
</script>
